var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyAccount = function SvgMyAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M5.947 14.914a4.75 4.75 0 0 1 3.358-1.39h5.39a4.75 4.75 0 0 1 4.748 4.747v1.468a.761.761 0 1 1-1.522 0V18.27a3.226 3.226 0 0 0-3.226-3.225h-5.39a3.226 3.226 0 0 0-3.226 3.225v1.468a.761.761 0 1 1-1.522 0V18.27c0-1.259.5-2.466 1.39-3.357M11.999 5.022a2.58 2.58 0 1 0 0 5.16 2.58 2.58 0 0 0 0-5.16m-4.103 2.58a4.102 4.102 0 1 1 8.205 0 4.102 4.102 0 0 1-8.205 0",
    clipRule: "evenodd"
  })));
};
export default SvgMyAccount;